



































import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    attachments: { type: Array, required: true }
  },
  data() {
    return {
      icons: {
        remove: faTimesCircle
      },
      allowedImages: ['image/jpeg', 'image/jpg', 'image/png']
    }
  },
  methods: {
    isImage(attachment) {
      if (attachment.content_type) {
        return this.allowedImages.includes(attachment.content_type)
      }

      return attachment.type && attachment.type === 'image'
    },
    imageLink(attachment) {
      if (attachment.domain && attachment.file) {
        return attachment.domain + attachment.file
      } else if (attachment.thumb) {
        return attachment.thumb
      }

      return ''
    }
  }
})
